export enum PermissionAction {
  Read = 'Read',
  Write = 'Write',
  Delete = 'Delete',
}

export enum PermissionMode {
  Hidden = 'hidden',
  ReadOnly = 'read-only',
  ReadWrite = 'read-write',
}

export enum PermissionResource {
  AccessRoles = 'AccessRoles',
  BaselineDocuments = 'BaselineDocuments',
  Clauses = 'Clauses',
  Counterparties = 'Parties',
  DataManagement = 'DataManagement',
  DocumentStatuses = 'DocumentStatuses',
  DocumentGeneration = 'DocumentGeneration',
  DocumentProcessing = 'DocumentProcessing',
  DocumentSignature = 'DocumentSignature',
  DocumentTypes = 'DocumentTypes',
  Documents = 'Documents',
  ExtractionMetadata = 'ExtractionMetadata',
  FileUpload = 'FileUpload',
  Groups = 'Groups',
  KeyQuestions = 'KeyQuestions',
  Parties = 'Parties',
  Permissions = 'Permissions',
  Playbooks = 'Playbooks',
  Positions = 'Positions',
  Profile = 'UserProfile',
  Questions = 'KeyQuestions',
  Reporting = 'Reporting',
  Recipients = 'Recipients',
  Templates = 'Templates',
  TeamRoles = 'TeamRoles',
  Users = 'Users',
  VarianceAnalysis = 'VarianceAnalysis',
  Workspaces = 'Workspaces',
}

export function buildPermissionCode(
  resource: PermissionResource | string,
  action: PermissionAction,
): string {
  return `${resource}.${action}`;
}
